import React from "react";
import Card from "components/card";
import { useSelector, connect } from "react-redux";
import { formatLeaveDate, calculateTotalDays,MODULE_LEAVE } from "variables/constants";
import LeaveForm from "./LeaveForm";
import CrudOption from "components/dropdown/crudoption";
import {
    doLeaveDelete
} from "../../../../redux/leave/leaveState";

const LeaveCard = ({ 
    recordList,
    doDelete
}) => {
    const currentUserLevel = useSelector((state) => state.auth.user.user_level);
    
    return (
        <>
            {recordList?.map((item) => {
                const statusKey = item.lve_status_name.toLowerCase();

                return (
                    <Card
                        key={item.lve_id}
                        className="p-4 border border-slate-200 rounded-2xl hover:shadow-md transition-all mb-4"
                    >
                        <div className="grid grid-cols-[1fr_auto] gap-4 items-start md:grid-cols-12">
                            <div className="md:col-span-9">
                                <div className="md:grid md:grid-cols-9 md:gap-4">
                                    <div className="md:col-span-4">
                                        {currentUserLevel !== 5 && (
                                            <p className="text-base font-semibold text-slate-700 dark:text-white/70 min-h-[24px]">
                                                {item.lve_employee_name}
                                            </p>
                                        )}

                                        <p className="text-sm font-semibold dark:text-white">
                                            {formatLeaveDate(item.lve_date_from, item.lve_date_to)}
                                        </p>
                                    </div>
                                    <div className="mt-2 md:mt-0 md:col-span-5">
                                        <p className="text-xs uppercase tracking-wide text-slate-500">
                                            Reason
                                        </p>

                                        {item.lve_status_name === "Pending" ? (
                                            <p className="text-sm text-slate-700 dark:text-slate-200">
                                                {item.lve_reason}
                                            </p>
                                        ) : (
                                            <p className="text-sm text-slate-700 dark:text-slate-200">
                                                {item.lve_note}
                                            </p>
                                        )}
                                    </div>
                                </div>
                            </div>
                            <div className="flex items-start gap-2 md:col-span-3 md:justify-end">
                                <span className={`status-indicator ${statusKey}`}>
                                    {item.lve_status_name}
                                </span>

                                {item.lve_status_name === "Pending" && (
                                    <div className="-mt-0.5">
                                        <CrudOption
                                            buttonClassName="inline-flex items-center rounded-xl border border-slate-300 px-2 py-0.5 text-xs hover:bg-slate-50 dark:border-slate-600 dark:hover:bg-slate-800 dark:text-white/70"
                                            baseRoute="/console/leaves"
                                            recordId={item.lve_id}
                                            moduleId={MODULE_LEAVE}
                                            title="Edit Leave"
                                            editMode="modal"
                                            allowView={false}
                                            allowEdit
                                            allowDelete={false}
                                            allowDetail={false}
                                            allowCancel
                                            deleteHandler={doDelete}
                                            editHandler={(recordId, closeModal) => (
                                                <div className="max-h-[80vh] overflow-y-auto">
                                                    <LeaveForm
                                                        recordId={recordId}
                                                        mode="edit"
                                                        onCancel={closeModal}
                                                    />
                                                </div>
                                            )}
                                        />
                                    </div>
                                )}
                            </div>
                        </div>

                        <div className="mt-4 border-t pt-3 flex justify-between text-sm dark:text-white/70">
                            <span className="flex items-center gap-2">
                                <span>{item.lve_type_name}</span>

                                {item.lve_is_unpaid ? (
                                    <span className="rounded-full bg-red-100 px-2 py-0.5 text-xs font-medium text-red-700 dark:bg-red-900/30 dark:text-red-300">
                                        LWOP
                                    </span>
                                ) : null}
                            </span>

                            <span>
                                {item.lve_is_undertime
                                    ? `Undertime • ${item.lve_undertime_duration}`
                                    : `${calculateTotalDays(item.lve_date_from, item.lve_date_to)} day(s)`}
                            </span>
                        </div>
                    </Card>
                );
            })}
        </>
    );
};

const mapStateToProps = (state) => ({
});

const mapDispatchToProps = (dispatch) => ({
    doDelete: (id) => dispatch(doLeaveDelete(id)),
});

export default connect(mapStateToProps, mapDispatchToProps)(LeaveCard);
